var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.269 5.72404C13.2374 5.65169 13.1931 5.58554 13.1383 5.52871L9.13833 1.52871C9.08149 1.4739 9.01535 1.42965 8.94299 1.39804C8.92299 1.38871 8.90166 1.38337 8.88032 1.37604C8.82454 1.35706 8.76647 1.34562 8.70766 1.34204C8.69366 1.34071 8.68099 1.33337 8.66699 1.33337H4.00033C3.26499 1.33337 2.66699 1.93137 2.66699 2.66671V13.3334C2.66699 14.0687 3.26499 14.6667 4.00033 14.6667H12.0003C12.7357 14.6667 13.3337 14.0687 13.3337 13.3334V6.00004C13.3337 5.98604 13.3263 5.97337 13.325 5.95871C13.3217 5.89985 13.3103 5.84174 13.291 5.78604C13.2843 5.76471 13.2783 5.74404 13.269 5.72404ZM11.0577 5.33337H9.33366V3.60937L11.0577 5.33337ZM4.00033 13.3334V2.66671H8.00033V6.00004C8.00033 6.17685 8.07056 6.34642 8.19559 6.47145C8.32061 6.59647 8.49018 6.66671 8.66699 6.66671H12.0003L12.0017 13.3334H4.00033Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 8.00004H10.6663V9.33337H5.33301V8.00004ZM5.33301 10.6667H10.6663V12H5.33301V10.6667ZM5.33301 5.33337H6.66634V6.66671H5.33301V5.33337Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.0ecfd45d.svg";
export { ForwardRef as ReactComponent };